import { render, staticRenderFns } from "./CardWaiting.vue?vue&type=template&id=efb1e6cc&"
import script from "./CardWaiting.vue?vue&type=script&lang=js&"
export * from "./CardWaiting.vue?vue&type=script&lang=js&"
import style0 from "./CardWaiting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports